import { Navigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { getLastApprenantId } from '../../../lib/useLastApprenantId.js';

/**
 * Index page /apprenants — V2 n'a pas (encore) de vraie liste, donc :
 *  - Si on a une dernière fiche consultée mémorisée → on y redirige
 *  - Sinon → on retombe sur la démo Martine en montrant un message clair
 *
 * Évite que cliquer sur "Apprenants" depuis Documents/Comm/Forms renvoie
 * toujours sur Martine (bug Rafik 29/05/2026).
 *
 * TODO : remplacer par une vraie liste paginée + filtrable (Task #88).
 */
export function ApprenantsIndexPage() {
  const last = getLastApprenantId();
  if (last) {
    return <Navigate to={`/apprenants/${last}`} replace />;
  }
  return (
    <div className="mx-auto mt-20 max-w-md rounded-xl border border-neutral-200 bg-white p-6 text-center shadow-sm">
      <Users className="mx-auto mb-3 h-10 w-10 text-neutral-400" />
      <h2 className="mb-1 text-base font-bold text-neutral-900">Aucun apprenant récent</h2>
      <p className="mb-4 text-xs text-neutral-600">
        La liste paginée arrive bientôt. En attendant, tu peux ouvrir une fiche depuis Zoho ou
        consulter la démo.
      </p>
      <a
        href="/apprenants/demo-martine"
        className="bg-primary-600 hover:bg-primary-700 inline-flex rounded px-3 py-1.5 text-xs font-semibold text-white"
      >
        Ouvrir la démo Martine
      </a>
    </div>
  );
}
